/** Created by azhou on 2019/3/28.*/
<template>
    <div>
      <!--景区的营业时间-->
      <div class="d-center-between mb-3">
        <div class="w-45 d-center-start">
          <left-text leftText="营业时间" required/>
          <el-time-picker is-range v-model="open_hours" range-separator="-" value-format="HH:mm" format="HH:mm"
                          start-placeholder="开始营业时间" end-placeholder="结束营业时间" class="w-100"/>
        </div>
        <div class="w-45 d-center-start" v-if="brand">
          <left-text required leftText="开业时间" />
          <el-date-picker class="w-100" size="small" v-model="BasicInfo.startdate" type="date" placeholder="选择开业时间" />
        </div>
      </div>
      <div class="d-start-start mb-3">
        <left-text leftText="时间备注" />
        <left-text-border type="textarea"  v-model="open_remarks" class="w-100"
                          placeholder="营业时间备注，例如：(周二-周日（周一闭馆，国定假日除外），16:00后停止售票)"/>
      </div>
      <div v-if="brand">
        <div class="d-center-start mb-3">
          <left-text required leftText="接待资质" />
          <el-radio-group v-model="BasicInfo.reception_qualification">
            <el-radio :label="item.id" v-for="item in $GVAR.receptionAccess" :key="item.name">{{item.name}}</el-radio>
          </el-radio-group>
        </div>
        <div class="d-start-start mb-3" v-for="parentItem in HMutiChooseFeatures" :key="parentItem.leftText">
          <left-text :leftText="parentItem.leftText"/>
          <el-checkbox-group v-model="BasicInfo[parentItem.value]" class="text-left">
            <el-checkbox class="ml-0 mr-2 mb-2" :label="item.id" v-for="item in $GVAR[parentItem.GVar]" :key="item.name">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="d-start-start mb-3" v-for="parentItem in HOtherChooseFeatures" :key="parentItem.leftText">
          <left-text :leftText="parentItem.leftText"/>
          <div class="w-100">
            <el-input v-model="BasicInfo[parentItem.value]"/>
            <div class="mt-2 text-left text-muted">
              <span class="h6">推荐选择：</span>
              <el-radio-group v-model="BasicInfo[parentItem.value]">
                <el-radio :label="item" v-for="item in $GVAR[parentItem.GVar]" :key="item">{{item}}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <left-text-border leftText="宣传口号" v-model="BasicInfo.slogan" placeholder="请输入宣传口号"/>
        <!--景区预订须知-->
        <div class="d-center-start mb-2">
          <left-text leftText="预订须知" />
          <el-tabs v-model="activeName">
            <el-tab-pane :label="item.title" :name="item.value" v-for="item in orderInfoArr" :key="item.value"/>
          </el-tabs>
        </div>
        <div class="d-center-start mb-2">
          <left-text />
          <left-text-border type="textarea"  v-model="BasicInfo[activeName]" class="w-100"
                            :placeholder="orderInfoPlaceholder"/>
        </div>
      </div>
      <!--景点,品牌馆介绍-->
      <div class="d-start-start mb-4">
        <left-text :leftText="storeInfo.type == 6 ? '景点介绍' : '品牌馆介绍'"/>
        <rich-editor class="w-100" v-model="BasicInfo.intro" :allowUploadImg="false" :contentProps="BasicInfo.intro"/>
      </div>
      <div class="d-start-start mt-4" v-if="brand">
        <left-text leftText="电子章"/>
        <upload-image @fileChange="(imgs)=>{this.seal = imgs[0];}" :existImgs="BasicInfo.seal" :maxLength="1" editMode/>
      </div>
      <el-button @click="submitForm" class="mt-4 btn-login">保存信息</el-button>
    </div>
</template>

<script>
  import { mapGetters,mapState } from 'vuex'
  import RichEditor from '../../../../components/Editor/RichEditor'
  import { UploadImages } from '@/assets/utils/uploadFiles'

  export default {
    name: 'SStoreBasic',
    components: { RichEditor },
    computed: {
      ...mapState(['StoreBasicInfo']),
      ...mapGetters(['storeInfo','isAdmin','brand']),
      orderInfoPlaceholder() {
        return (this.orderInfoArr.filter(item => item.value === this.activeName))[0].placeholder
      }
    },
    data () {
      return {
        BasicInfo: {},
        open_hours:[new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 17, 40)],                    //景区营业时间
        open_remarks:'',                                                                              //景区营业时间备注
        orderInfoArr:[
          {title:'团队门票政策',value:'team_policy',placeholder:'针对采购商的团队门票政策'},
          {title:'免费政策',value:'free_policy',placeholder:'例如：a. 1.1米（不含）以下的儿童免票。（免票）'},
          {title:'优惠政策',value:'favoured_policy',placeholder:'例如：a. 1.1米（不含）～1.4米（含）的儿童享半价'},
          {title:'重要说明',value:'explanation',placeholder:'例如：可备注与景区相关的重要说明'},
          {title:'安全须知',value:'safety_notice',placeholder:'例如：为了您人身、财产的安全，请您避免在公开场合暴露贵重物品及大量现金。外出时需时刻看管好首饰、相机等随身物品。'},
        ],
        activeName:'team_policy',
        HMutiChooseFeatures:[
          {leftText:'门店设施',value:'features',GVar:'FacilitiesBasic'},
          {leftText:'主题特色',value:'type_label',GVar:'BrandTheme'},
        ],
        HOtherChooseFeatures:[
          {leftText:'司陪政策',value:'escort_policy',GVar:'escortPolicyArr'},
          {leftText:'最低成团',value:'min_team_num',GVar:'minTeamNumArr'},
        ],
        seal: ''
      }
    },
    watch: {
      StoreBasicInfo () {
        this.initStoreInfo()
      },
    },
    created () {
      this.initStoreInfo()
    },
    methods:{
      /*门店信息初始化*/
      initStoreInfo() {
        let y = new Date().getFullYear();
        let m = new Date().getMonth()+1;
        let d = new Date().getDate();
        if (this.StoreBasicInfo.open_hours){
          let hours = this.StoreBasicInfo.open_hours.split('/azhou/');
          this.open_remarks = hours[1];
          let Start = hours[0].split('-')[0];
          let End = hours[0].split('-')[1];
          let hStart = parseInt(Start.split(':')[0]);
          let mStart = parseInt(Start.split(':')[1]);
          let hEnd = parseInt(End.split(':')[0]);
          let mEnd = parseInt(End.split(':')[1]);
          this.open_hours = [
            new Date(y, m, d, hStart, mStart), new Date(y, m, d, hEnd, mEnd)
          ];
        }
        this.BasicInfo = {
          ...this.StoreBasicInfo,
          startdate:this.StoreBasicInfo.startdate == 0 ? '' :this.StoreBasicInfo.startdate * 1000,
        };
      },
      /*表单验证，管理员不需要校验必填项*/
      validateForm() {
        if (!this.isAdmin) {
          if (!this.open_hours) return {code:false,msg:'星号为必填项，请检查表单'}
        }
        return {code:true,msg:'验证通过'}
      },
      submitForm() {
        let result = this.validateForm();
        if (result.code) {
          // if (!this.$GFUN.powerIsInArray([95,363,428,99,234,155,271,370,618])) { this._alert('您没有相关权限！',null,'error'); return; }
          this._confirm('确定提交信息么？',async () => {
            //element-ui时间选择器组件在没有点击事件时，获取的open_hours是Date类型，需要处理后再提交
            if (this.open_hours[0] instanceof Date) {
              this.open_hours = this.open_hours.map(item => {
                let hour = item.getHours() < 9 ? ('0' + item.getHours()) : item.getHours();
                let min = item.getMinutes() < 9 ? ('0' + item.getMinutes()) : item.getMinutes();
                return hour + ':' + min;
              });
            }
            this.BasicInfo.seal = (await UploadImages(this.seal))[0]
            let info = {
              ...this.BasicInfo,
              open_hours:[this.open_hours.join('-'),this.open_remarks.replace(/(\<br\/\>){2,}/g, "<br/>")].join('/azhou/'),
              startdate:this.BasicInfo.startdate / 1000,
            }
            this.$emit('saveInfo',info)
          })
        } else this._alert(result.msg,null,'error');
      }
    }
  }
</script>
